module.exports = __webpack_public_path__ + "ui-static/img/hooks-no-items_dark.dac70e70.svg";